import clsx from 'clsx'
import '../../styles/slp.css'

export type LampStatus = 'ok' | 'warn' | 'error' | 'off'

const COLOR: Record<LampStatus, string> = {
  ok: 'var(--slp-lamp-green)',
  warn: 'var(--slp-lamp-yellow)',
  error: 'var(--slp-lamp-red)',
  off: 'var(--slp-lamp-off)',
}

const LABEL: Record<LampStatus, string> = {
  ok: 'online',
  warn: 'warning',
  error: 'error',
  off: 'offline',
}

/**
 * SLP status lamp — small round light: green (online) / yellow (warning) /
 * red (error) / gray (offline). Online lamps get a soft glow like SLP's
 * ON AIR dots.
 */
export function StatusLamp({
  status,
  label,
  size = 'md',
  className,
}: {
  status: LampStatus
  /** Accessible label; defaults to the status name. */
  label?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}) {
  const px = size === 'lg' ? 14 : size === 'md' ? 10 : 8
  return (
    <span
      role="status"
      aria-label={label ?? LABEL[status]}
      data-status={status}
      className={clsx('inline-block shrink-0 rounded-full', className)}
      style={{
        width: px,
        height: px,
        background: COLOR[status],
        boxShadow:
          status === 'ok'
            ? '0 0 4px 1px rgba(46, 204, 64, 0.55)'
            : status === 'error'
              ? '0 0 4px 1px rgba(232, 69, 60, 0.45)'
              : undefined,
      }}
    />
  )
}
